import React, { useEffect, useState, useCallback, useRef } from "react";
import FormTextArea from "./form-components/FormTextArea";
import FormValue from "./form-components/FormValue";
import FormDatePicker from "./form-components/FormDatePicker";
import FormRadioList from "./form-components/FormRadioList";
import FormCheckboxList from "./form-components/FormCheckboxList";
import MedicalFillInFormOverlay from "./MedicalFillInFormOverlay";
import Show from "../../../widgets/Show";
import medicalFillInFormItemTypes from "../../../../constants/chart-sidebar/medicalFillInFormItemTypes";
import questionTypeCodes from "../../../../constants/chart-sidebar/questionTypeCodes";
import _, { last } from "lodash";
import $ from "jquery";
import ReactDOMServer from "react-dom/server";
import FormCanvas from "./form-components/FormCanvas";
import FormGenerateFormula from "./form-components/FormGenerateFormula";
import FormPatientDocs from "./form-components/FormPatientDocs";
import Utils from "../../../../helpers/Utils";
import { DATE_FORMAT_LEGACY, FULL_DATE_FORMAT, TIME_FORMAT } from "../../../../constants/Constants";
import FormCheckboxListWithComment from "./form-components/FormCheckboxListWithComment";
import MedicalFillInFormUtils from "./form-helpers/FormUtils";
import MedicalFillInFormQuestionModal from "./MedicalFillInFormQuestionModal";
import { useLocation } from "react-router";
import { parseQuery } from "../../../../utils/UrlUtils";
import { useDispatch } from "react-redux";
import { openSimpleModal } from "../../../../actions/simpleModalActions";
const NA = "N/A";

const MedicalFIllInFormItem = ({
  setForm,
  form,
  chartSideMedicalFillInForm,
  editMode,
  images,
  clinicName,
  consultation = null,
  onSaveItem,
}) => {
  const location = useLocation();
  const allParams = parseQuery(location.search);

  const isEditMode = allParams.medicalType !== "view";

  const { item, stack, activeTab, empty, questionsModalVisible } = chartSideMedicalFillInForm;

  const [overlay, setOverlay] = useState({ visible: false });
  const [canvasImage, setCanvasImage] = useState("");
  const [patientImage, setPatientImage] = useState("");
  const loadedImagesRef = useRef(new Set());
  const dispatch = useDispatch();
  const lastStack = last(stack);

  const getTemplate = useCallback(
    (template = "") => {
      if (!template) return null;

      const reqExp = /\[\[[^\]]*]]/g;
      const { patient, member } = empty;

      return template.replace(reqExp, (match) => {
        const code = match.slice(2, -2);
        let pickListQuestion = false;

        template.replace(/PICKLIST/g, (m) => {
          if (m === "PICKLIST") pickListQuestion = true;
        });
        const currentQuestion = (item.questions || []).find((item) => item.code === code);
        const hasPickListOptions = currentQuestion && currentQuestion?.options?.length;

        if (pickListQuestion && hasPickListOptions) {
          const columns = Number(currentQuestion.typeCode.replace(/^\D+/g, "") || 0);
          let gridColumns = "auto ".repeat(columns);

          const pickListRootStyle = `
          text-decoration: none;
          display: inline-grid;
          gap: 10px;
          padding: 10px;
          grid-template-columns: ${gridColumns}`;

          let result = `<div style="${pickListRootStyle}">
            ${currentQuestion?.options?.map((option, index) => {
              const indexNumber = index + 1;
              const isLeftOpeningCommentBox = MedicalFillInFormUtils.isInSeries(indexNumber);
              const hasComment = MedicalFillInFormUtils.hasValidComment(option.comment);

              const btnStyles = `
                height: 100%;
                padding: 1px 4px;
                min-width: 80px;
                width: 100px;
                white-space: normal;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              `;

              return `<div style="position: relative">
                      <input 
                        type="hidden"
                        value="${option.comment || ""}"
                        class="hidden-pick-list-comment 
                        pl-hidden-comment-${currentQuestion.id}-${option.id}"
                        data-qna-id="${currentQuestion.id}-${option.id}" />
                      <button
                        style="${btnStyles}"
                        title="${option.title}"
                        data-index="${option.id}"
                        id="${currentQuestion.id}-${option.id}"
                        value="pick-list-${currentQuestion.id}"
                        class="pick-list-button btn btn-sm ${
                          option.selected ? "btn-success" : "btn-default"
                        }">
                        ${option.title}
                        ${
                          currentQuestion.canAddComment || option.title === "Other"
                            ? `<div 
                                      data-question-id="${currentQuestion.id}"
                                      data-answer-id="${option.id}"
                                      data-comment="${option.comment}"
                                      data-is-left-opening="${
                                        isLeftOpeningCommentBox && columns > 5
                                      }"
                                      onmouseover="this.style.height='16px'; this.style.width='16px';" 
                                      onmouseout="this.style.height='12px'; this.style.width='12px';" 
                                      class="pl-comment-toggler-badge-plus pl-comment-badge-${
                                        currentQuestion.id
                                      }-${option.id}" style="${MedicalFillInFormUtils.badgeStyle(
                                hasComment,
                              )}">${hasComment ? 1 : "&plus;"}</div>`
                            : ""
                        }
                      </button>
                    </div>`;
            })}
          </div>`;
          return result.replaceAll(",", "");
        }
        if (code === "Current date") {
          return Utils.parseDateFormat(Utils.calcDateWithTimeZone(), DATE_FORMAT_LEGACY);
        }
        if (code === "Current time") {
          return Utils.parseDateFormat(Utils.calcDateWithTimeZone(), TIME_FORMAT);
        }
        if (code === "Patient chart number") {
          return patient && patient.chartNumber;
        }
        if (code === "Patient age") {
          return patient && patient.age;
        }
        if (code === "Patient name") {
          return patient && patient.fullName;
        }
        if (code === "Patient nationality") {
          return _.get(patient, "nationality.name", "N/A");
        }
        if (code === "Patient primary insurance image") {
          for (const form in images) {
            for (const image in images[form]) {
              const { url } = images[form][image];

              if (url) {
                return `<img style="width: 100%; max-width: 300px" src=${url} alt="" />`;
              }
            }
          }
        }
        if (code === "Patient date of birth") {
          const dateFormat = localStorage.getItem("company-date-format");

          return Utils.parseDateFormat(
            Utils.calcDateWithTimeZone(patient && patient.dateOfBirth),
            dateFormat,
          );
        }
        if (code === "Dentist Name") {
          return member && member.name;
        }
        if (code === "Check-in date time") {
          return Utils.parseDateFormat(
            Utils.calcDateWithTimeZone(empty.checkedInDate),
            FULL_DATE_FORMAT,
          );
        }
        if (code === "Doctor license id") {
          return member && member.code;
        }
        if (code === "Patient last name") {
          return patient && patient.lastName;
        }
        if (code === "Patient first name") {
          return patient && patient.firstName;
        }
        if (code === "Patient primary card number") {
          return empty.primaryInsuranceCardNumber;
        }
        if (code === "Patient secondary card number") {
          return empty.secondaryInsuranceCardNumber;
        }
        if (code === "Patient gender") {
          return patient && patient.gender && patient.gender.name;
        }
        if (code === "Patient driver's licence number") {
          return patient && patient.documentDriverLicenseNumber;
        }
        if (code === "Patient social security number") {
          return patient && patient.documentSocialSecurityNumber;
        }
        if (code === "Patient social insurance number") {
          return patient && patient.documentSocialInsuranceNumber;
        }
        if (code === "Patient national id number") {
          return patient && patient.documentNationalIdNumber;
        }
        if (code === "Patient passport number") {
          return patient && patient.documentPasswordNumber;
        }
        if (code === "Clinic name") {
          return clinicName;
        }
        if (code === "Patient mobile number") {
          return patient && patient.mobilePhoneNumber;
        }
        return "N/A";
      });
    },
    [clinicName, empty, images, item.questions],
  );
  const imageUrlToDataURL = useCallback((url, callback) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const canvas = document.getElementById("canvasId");
        const resizedData = await resizePngDataUrl(
          reader.result,
          canvas?.width,
          canvas?.height,
          {},
        );
        callback(resizedData);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }, []);

  useEffect(() => {
    const handleLoadImage = (e) => {
      if (e.target.classList.contains("lazy-load-image-btn")) {
        const button = e.target;
        const encodedSrc = button.getAttribute("data-image-src");

        const dataIndex = button.getAttribute("data-image-index");
        const imgId = button.getAttribute("data-image-id");
        const imgClass = button.getAttribute("data-image-class");

        if (!encodedSrc) return;

        const imgSrc = atob(encodedSrc);

        button.textContent = "Loading...";
        button.disabled = true;

        const img = document.createElement("img");
        img.src = imgSrc;
        img.style.maxWidth = "100%";
        img.style.height = "auto";

        if (dataIndex) img.setAttribute("data-index", dataIndex);
        if (imgId) img.id = imgId;
        if (imgClass) img.className = imgClass + " loaded-dental-image";
        else img.className = "loaded-dental-image";

        img.onload = () => {
          const container = button.closest(".image-loader-container");
          if (container && container.parentNode) {
            container.parentNode.replaceChild(img, container);
            loadedImagesRef.current.add(imgSrc);
          }
        };

        img.onerror = () => {
          button.textContent = "Failed to load";
          button.disabled = false;
          button.classList.add("btn-danger");
        };
      }
    };

    document.addEventListener("click", handleLoadImage);
    return () => document.removeEventListener("click", handleLoadImage);
  }, []);

  useEffect(() => {
    setForm(item);
  }, [activeTab, item, setForm]);

  useEffect(() => {
    if (item.template) {
      const newItem = { ...item };
      newItem.template.templateBody = getTemplate(item.template?.templateBody);
      setForm(newItem);
    }
  }, [getTemplate, item, item.template, setForm]);

  const setTemplateData = (event) => {
    if (!editMode) return;

    if (event.target.dataset?.index) {
      if (event.target.value && event.target.value.indexOf("pick-list") !== -1) {
        const id = Number(event.target.dataset.index || 0);
        setForm({
          ...form,
          questions: form.questions.map((question) => {
            if (question.id === Number(event.target.value.replace(/^\D+/g, "") || 0)) {
              question.options = question.options.map((answer) => {
                if (answer.id === id) {
                  answer.selected = !answer.selected;
                  if (answer.selected) {
                    document.getElementById(event.target.id).classList.remove("btn-default");
                    document.getElementById(event.target.id).classList.add("btn-success");
                  } else {
                    document.getElementById(event.target.id).classList.remove("btn-success");
                    document.getElementById(event.target.id).classList.add("btn-default");
                  }
                }
                return answer;
              });
            }
            return question;
          }),
        });
        return;
      }
      const id = event.target.dataset.index;
      const question = item.questions.find((item) => Number(item.id) === Number(id));
      if (question.typeCode === "CANVAS" && !canvasImage) {
        dispatch(
          openSimpleModal({
            body: "Downloading an image for canvas form, close this modal and try again",
          }),
        );
        return;
      }
      setOverlay({
        visible: true,
        innerWidth: event.view.innerWidth,
        innerHeight: event.view.innerHeight,
        top: event.clientY,
        left: event.clientX,
        question: question.question || "",
        typeCode: question.typeCode,
        currentQuestionId: question.id,
        component: getField(question.typeCode, question.id, true, question.canAddComment),
      });
    }
  };

  useEffect(() => {
    let timeOutForClosing = null;

    const container = document.querySelector(".medical-fill-in-form-question");

    if (container) {
      const handleClick = (e) => {
        if (
          (editMode && e.target.classList.contains("pl-comment-toggler-badge-plus")) ||
          e.target.classList.contains("pl-comment-toggler-badge")
        ) {
          const questionId = Number(e.target.dataset.questionId);
          const answerId = Number(e.target.dataset.answerId);
          const isLeftOpening = e.target.dataset.isLeftOpening === "true";
          const commentBox = $(`#${questionId}-${answerId} + .pl-comment-popup-box`);
          if (commentBox.length) {
            commentBox.remove();
            return;
          }
          const commentPopupStyles = `
          position: absolute;
          top: calc(100% + 6px);
          ${isLeftOpening ? "right" : "left"}: 0px;
          z-index: 9;
          background: white;
          padding: 5px 10px;
          border-radius: 5px;
          box-shadow: 0 0 8px #00000050;
          min-width: 250px;`;

          $(`#${questionId}-${answerId}`).after(`
            <div class="pl-comment-popup-box" style="${commentPopupStyles}">
              <div class="d-flex justify-content-between">
                <span class="pl-remarks">Remarks</span>
                <span class="pl-close-popup" data-question-id="${questionId}" data-answer-id="${answerId}">&times;</span>
              </div>
              <textarea
                style="height: ${isEditMode ? "100px" : "auto"}"
                class="form-control pick-list-comment pl-comment-${questionId}-${answerId}"
                id="${questionId}-${answerId}-textarea"
              ></textarea>
              <div class="pl-save-btn">
                <button class="btn btn-sm btn-success close-popup-button" 
                data-question-id="${questionId}" data-answer-id="${answerId}">${
            isEditMode ? "Save" : "Ok"
          }</button>
              </div>
            </div>
          `);
          if (!form.questions.length) return;
          const currentQuestion = form.questions.find(
            (item) => Number(item.id) === Number(questionId),
          );
          const currentOption = currentQuestion.options.find(
            (option) => Number(option.id) === Number(answerId),
          );
          $(`#${questionId}-${answerId}-textarea`)
            .val(currentOption.comment)
            .on("input change", function () {
              setForm({
                ...form,
                questions: form.questions.map((question) => {
                  if (question.id === questionId) {
                    (question.options || []).map((option) => {
                      if (option.id === answerId) {
                        option.comment = $(this).val();
                      }
                      return option;
                    });
                  }
                  return question;
                }),
              });
            });
          return;
        }

        if (e.target.classList.contains("close-popup-button")) {
          const questionId = Number(e.target.dataset.questionId);
          const answerId = Number(e.target.dataset.answerId);
          const popupContainer = $(`#${questionId}-${answerId} + div`);

          if (!isEditMode) {
            popupContainer.remove();
          }

          const currentQuestion = form.questions.find(
            (item) => Number(item.id) === Number(questionId),
          );
          const currentOption = currentQuestion.options.find(
            (option) => Number(option.id) === Number(answerId),
          );
          const comment = currentOption.comment || "";
          const hiddenComment = document.querySelector(
            `.pl-hidden-comment-${questionId}-${answerId}`,
          );
          const hasComment = MedicalFillInFormUtils.hasValidComment(comment);
          hiddenComment.value = comment || "";

          $(`.pl-comment-badge-${questionId}-${answerId}`).remove();
          $(`#${questionId}-${answerId}`).append(`<div
                                data-question-id="${questionId}"
                                data-answer-id="${answerId}"
                                data-comment="${comment?.innerText}"
                                onmouseover="this.style.height='16px'; this.style.width='16px';"
                                onmouseout="this.style.height='12px'; this.style.width='12px';"
                                class="pl-comment-toggler-badge pl-comment-badge-${questionId}-${answerId}" 
                                style="${MedicalFillInFormUtils.badgeStyle(hasComment)}">${
            hasComment ? 1 : "&plus;"
          }</div>`);

          timeOutForClosing = setTimeout(() => {
            popupContainer.remove();
          }, 100);
        }

        if (e.target.classList.contains("pl-close-popup")) {
          const questionId = Number(e.target.dataset.questionId);
          const answerId = Number(e.target.dataset.answerId);
          const popupContainer = $(`#${questionId}-${answerId} + div`);
          popupContainer.remove();
        }
      };

      container.addEventListener("click", handleClick);

      return () => {
        clearTimeout(timeOutForClosing);
        container.removeEventListener("click", handleClick);
      };
    }
  }, [editMode, form, isEditMode, setForm]);

  useEffect(() => {
    if (consultation?.questions.length) {
      setForm(consultation);
    }
  }, [consultation, consultation?.questions, setForm]);

  useEffect(() => {
    if (document.querySelector("span[data-index]")) {
      const elements = document.querySelectorAll("span[data-index]");
      elements.forEach((element) => {
        const question = form.questions.find((i) => Number(i.id) === Number(element.dataset.index));
        if (question) {
          if (question.typeCode === questionTypeCodes.CANVAS) {
            imageUrlToDataURL(
              question?.answerFile || question?.answerPhoto?.url || question?.questionPhoto?.url,
              (dataUrl) => {
                setCanvasImage(dataUrl);
              },
            );
            element.innerHTML = `${ReactDOMServer.renderToString(
              <img
                data-index={question.id}
                alt="canvas"
                id="canvasId"
                className="canvas-image"
                src={
                  question?.answerFile || question?.answerPhoto?.url || question?.questionPhoto?.url
                }
              />,
            )}`;
            return;
          }
          if (question.typeCode === questionTypeCodes.IMAGE) {
            if (!(question?.answerFile || question?.answerPhoto?.url)) {
              element.innerHTML = NA;
              return;
            }
            imageUrlToDataURL(
              question?.answerFile || question?.answerPhoto?.url || question?.questionPhoto?.url,
              (dataUrl) => {
                setPatientImage(dataUrl);
              },
            );
            element.innerHTML = `${ReactDOMServer.renderToString(
              <img
                data-index={question.id}
                alt="mouth"
                id="mouthId"
                className="mouth-image"
                src={
                  question?.answerFile || question?.answerPhoto?.url || question?.questionPhoto?.url
                }
              />,
            )}`;
            return;
          }
          if (question.typeCode === questionTypeCodes.FORMULA) {
            element.innerHTML = Utils.calculateStringToNumber(question?.answer) || NA;
            return;
          }
          if (question?.options?.length) {
            if (question.typeCode.replace(/[^a-z]/gi, "") === questionTypeCodes.PICKLIST) {
              // const commentBoxes = document.querySelectorAll(".pick-list-comment");
              //
              // for (let i = 0; i < commentBoxes.length; i++) {
              //   commentBoxes[i].addEventListener("click", function () {
              //     insertAfter(question.id, answer.id);
              //   });
              // }
              return "";
            }
            const { options } = question;
            const value = options
              .map((option) => {
                let answer = "";
                if (option.selected) {
                  answer = `${option.otherValue || (!option.other ? option.title : NA)} <br>`;
                  if (option.comment) {
                    answer = answer + `${option.comment} <br>`;
                  }
                }
                return answer;
              })
              .join("");
            element.innerHTML = value || NA;
          } else {
            element.innerHTML = question?.answer || question?.defaultAnswer || NA;
          }
        }
      });
    }

    setTimeout(() => {
      const allImages = document.querySelectorAll(".medical-fill-in-form-question__body img");
      allImages.forEach((img) => {
        if (img.classList.contains("loaded-dental-image")) {
          return;
        }

        const imgSrc = img.src || img.getAttribute("src");
        if (imgSrc) {
          if (loadedImagesRef.current.has(imgSrc)) {
            return;
          }

          const dataIndex = img.getAttribute("data-index");
          const imgId = img.id;
          const imgClass = img.className;

          const buttonContainer = document.createElement("div");
          buttonContainer.className = "image-loader-container";
          buttonContainer.innerHTML = `
            <div style="
              background: white;
              border: 1px solid #e9ecef;
              border-radius: 10px;
              padding: 20px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
              transition: all 0.3s ease;
              text-decoration: unset;
            "
            onmouseover="this.style.boxShadow='0 4px 16px rgba(0,0,0,0.12)';"
            onmouseout="this.style.boxShadow='0 2px 8px rgba(0,0,0,0.08)';">
              <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
                <div style="
                  width: 40px;
                  height: 40px;
                  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                  border-radius: 8px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-shrink: 0;
                ">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <circle cx="8.5" cy="8.5" r="1.5"></circle>
                    <polyline points="21 15 16 10 5 21"></polyline>
                  </svg>
                </div>
                <div style="flex: 1;">
                  <div style="font-size: 14px; font-weight: 600; color: #212529; margin-bottom: 2px;">Dental Image</div>
                  <div style="font-size: 12px; color: #6c757d;">Click to load and view</div>
                </div>
              </div>
              <button 
                class="btn btn-primary btn-sm btn-block lazy-load-image-btn" 
                data-image-src="${btoa(imgSrc)}"
                data-image-src="${btoa(imgSrc)}"
                data-image-index="${dataIndex || ""}"
                data-image-id="${imgId || ""}"
                data-image-class="${imgClass || ""}"
                style="
                  font-size: 13px;
                  padding: 10px;
                  border-radius: 6px;
                  font-weight: 500;
                  width: 100%;
                ">
                Load Image
              </button>
            </div>
      `;
          img.parentNode.replaceChild(buttonContainer, img);
        }
      });
    }, 0);
  }, [form.questions, imageUrlToDataURL, loadedImagesRef]);

  const getField = (questionTypeCode, questionId, visible, canAddComment = false) => {
    if (
      questionTypeCode === questionTypeCodes.TEXT ||
      questionTypeCode === questionTypeCodes.TEXT_AREA
    ) {
      return (
        <FormTextArea
          setOverlay={setOverlay}
          visible={visible}
          editMode={editMode}
          questionId={questionId}
          setForm={setForm}
          form={form}
          questionTypeCode={questionTypeCode}
        />
      );
    }
    if (questionTypeCode === questionTypeCodes.VALUE)
      return (
        <FormValue
          setOverlay={setOverlay}
          visible={visible}
          editMode={editMode}
          questionId={questionId}
          setForm={setForm}
          form={form}
        />
      );
    if (questionTypeCode === questionTypeCodes.DATE_PICKER)
      return (
        <FormDatePicker
          setOverlay={setOverlay}
          visible={visible}
          editMode={editMode}
          questionId={questionId}
          setForm={setForm}
          form={form}
        />
      );
    if (questionTypeCode === questionTypeCodes.RADIO_LIST)
      return (
        <FormRadioList
          setOverlay={setOverlay}
          visible={visible}
          editMode={editMode}
          questionId={questionId}
          setForm={setForm}
          form={form}
        />
      );
    if (questionTypeCode === questionTypeCodes.CHECKBOX_LIST && !canAddComment)
      return (
        <FormCheckboxList
          setOverlay={setOverlay}
          visible={visible}
          editMode={editMode}
          questionId={questionId}
          setForm={setForm}
          form={form}
        />
      );
    // if (questionTypeCode.replace(/[^a-z]/gi, "") === questionTypeCodes.PICKLIST)
    //   return (
    //     <FormPickList
    //       setOverlay={setOverlay}
    //       visible={visible}
    //       editMode={editMode}
    //       questionId={questionId}
    //       setForm={setForm}
    //       form={form}
    //     />
    //   );
    if (questionTypeCode === questionTypeCodes.CHECKBOX_LIST && canAddComment)
      return (
        <FormCheckboxListWithComment
          setOverlay={setOverlay}
          visible={visible}
          editMode={editMode}
          questionId={questionId}
          setForm={setForm}
          form={form}
        />
      );
    if (questionTypeCode === questionTypeCodes.CANVAS)
      return (
        <FormCanvas
          setOverlay={setOverlay}
          visible={visible}
          editMode={editMode}
          questionId={questionId}
          setForm={setForm}
          form={form}
          canvasImage={canvasImage}
        />
      );
    if (questionTypeCode === questionTypeCodes.FORMULA)
      return (
        <FormGenerateFormula
          setOverlay={setOverlay}
          visible={visible}
          editMode={editMode}
          questionId={questionId}
          setForm={setForm}
          form={form}
        />
      );
    if (questionTypeCode === questionTypeCodes.IMAGE)
      return (
        <FormPatientDocs
          setOverlay={setOverlay}
          visible={visible}
          editMode={editMode}
          questionId={questionId}
          setForm={setForm}
          form={form}
          isFromMedicalForm={true}
          patientImage={patientImage}
          questionTypeCode={questionTypeCode}
          questionTypeCodes={questionTypeCodes}
        />
      );
  };

  const resizePngDataUrl = (dataUrl, targetWidth, targetHeight, options = {}) => {
    const { smoothingEnabled = true, smoothingQuality = "high" } = options;

    return new Promise((resolve, reject) => {
      try {
        if (
          typeof dataUrl !== "string" ||
          !(
            dataUrl.startsWith("data:image/png;base64,") ||
            dataUrl.startsWith("data:image/jpeg;base64,") ||
            dataUrl.startsWith("data:image/jpg;base64,")
          )
        ) {
          return reject(new Error("Expecting PNG or JPEG data URL"));
        }

        const img = new Image();
        img.onload = () => {
          try {
            let width = targetWidth ?? null;
            let height = targetHeight ?? null;

            if (width == null && height == null) {
              width = img.naturalWidth || img.width;
              height = img.naturalHeight || img.height;
            } else if (width == null) {
              const scale = height / (img.naturalHeight || img.height);
              width = Math.max(1, Math.round((img.naturalWidth || img.width) * scale));
            } else if (height == null) {
              const scale = width / (img.naturalWidth || img.width);
              height = Math.max(1, Math.round((img.naturalHeight || img.height) * scale));
            }

            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext("2d");
            ctx.imageSmoothingEnabled = smoothingEnabled;
            ctx.imageSmoothingQuality = smoothingQuality;

            ctx.drawImage(img, 0, 0, width, height);

            const outDataUrl = canvas.toDataURL("image/png");
            resolve(outDataUrl);
          } catch (e) {
            reject(e);
          }
        };
        img.onerror = () => reject(new Error("Failed to load image from data URL"));
        img.src = dataUrl;
      } catch (e) {
        reject(e);
      }
    });
  };

  if (form.template) {
    const { template } = form;
    return (
      <div className="medical-fill-in-form-question">
        <MedicalFillInFormOverlay
          overlay={overlay}
          onClose={() => setOverlay({ visible: false })}
        />
        <div className="d-flex justify-content-between align-items-center mt-2 mb-2">
          <div className="medical-fill-in-form-question__title">{template.name}</div>
        </div>
        <div
          className="medical-fill-in-form-question__body"
          style={{ overflowX: "unset" }}
          dangerouslySetInnerHTML={{ __html: template.templateBody }}
          onClick={(event) => setTemplateData(event)}
        />
        <div className="medical-fill-in-form-question__body"></div>
        <div
          className="medical-fill-in-form-question__actions"
          style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}
        >
          <Show if={editMode}>
            <button className="btn btn-primary" onClick={onSaveItem}>
              {lastStack?.type === medicalFillInFormItemTypes.new ? "Save" : "Update"}
            </button>
          </Show>
        </div>

        <Show if={questionsModalVisible}>
          <MedicalFillInFormQuestionModal form={form} questionId={overlay?.currentQuestionId} />
        </Show>
      </div>
    );
  }
  return null;
};

export default MedicalFIllInFormItem;
